<script setup>
import Edit from '@/components/edit/Edit.vue';
import Alert  from '@/components/common/Alert.vue';
import Message  from '@/components/common/Message.vue';
import Load   from '@/components/common/Load.vue';
import Help   from '@/components/help/Help.vue';
import axios  from "axios";
import moment  from "moment";
import navi from '@/components/edit/EditorNavi.vue'
import graph from '@/components/edit/Graph.vue'
import Preview from '@/components/edit/Preview.vue'
import Correct from "@/components/confirm/Correct.vue"
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<div class="editorbox">
<v-card
	width="100%"
	flat
>
<v-toolbar
	height="40px"
	width="90%"
	flat
	style="margin: 0 auto;"
>
<v-spacer />
<Help :num="tab" />
</v-toolbar>
<v-card-text style="display:flex;">
<Message
	ref="message"
	title="GPTを使ってプレスリリースを自動作成します"
	message="本機能はopenAIのAPIを利用して実行されます。本機能はopenAIのエンタープライズプライバシーにより運用されており入力したデータをAIモデルの学習には利用されません。<a href='https://openai.com/enterprise-privacy' target=_blank>openAI エンタープライズプライバシーページ(外部サイト)</a>"
	v-on:messreturn="gptopen"
/>

<form action="https://docs.qlipper.jp/rel_file_gen.php" method="post" id="dl">
    <input type="hidden" name="title"  :value="title">
    <input type="hidden" name="stitle"  :value="sub_title">
    <input type="hidden" name="release_date" :value="release_date">
    <input type="hidden" name="rsummary" :value="summary">
    <input type="hidden" name="rdoc" :value="e_doc">
    <input type="hidden" name="signature" :value="doc_signature">
    <input type="hidden" name="direction" :value="direction">
</form>

    <div class="editormain">
	<v-card
		max-width="800px"
		flat
		style="margin : 0 auto;"
		class="mb-1"
	>
	<v-card-text class="px-0 py-0">
  <v-tabs
    fixed-tabs
    v-model="tab"
    background-color="#FDF0F0"
    color="#E13533"
  >
    <v-tabs-slider color="#E13533"></v-tabs-slider>
    <v-tab>編集</v-tab>
    <v-tab>プレビュー</v-tab>
    <v-tab>
		<v-badge
			:content="comment_cnt"
			:value="comment_cnt"
			color="error"
			overlap
		>
			赤入れ
		</v-badge>
	</v-tab>
  </v-tabs>
	</v-card-text>
  </v-card>
  <v-tabs-items v-model="tab">
      <v-tab-item>
        <Edit
            :doc_id="doc_id"
            v-on:robots="robots_sub_form($event)"
            v-on:garally="garally"
			v-on:blockupdated="save_reserv($event)"
			v-on:reservable="status_update"
			v-on:ai_reload="reload"
            ref="ed"
			v-if="load_flg==true"
			style="margin:0 auto"
        ></Edit>
		<Load v-else />
    </v-tab-item>
    <v-tab-item>
		<v-card
			max-width="750px"
			style="margin:0 auto;"
			flat
		>
		<Preview />
		</v-card>
    </v-tab-item>
    <v-tab-item>
		<v-card
			max-width="750px"
			style="margin:0 auto;"
			flat
		>
		<Correct ref="cor" v-on:docsave="save_doc" />
		</v-card>
    </v-tab-item>
  </v-tabs-items>

    </div>
    <div >
        <navi  class="editornavi" v-on:menu="editormenu($event)" />
        <graph ref="gr" v-on:selected_img="selected_img($event)" />
    </div>
            <v-dialog
                v-model="message_flg"
                width="500px"
            >
                <v-card>
                <v-toolbar
                    tile
                    flat
                    height = "50px"
                    color="#E13533"
                    dark
                >
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                v-on="on"
                                v-bind="attrs"
                                class="mr-3"
                                @click="message_flg=false"
                            >
                                mdi-close
                            </v-icon>
                            </template>
                            <span>閉じる</span>
                        </v-tooltip>
                </v-toolbar>
             <Alert
                :message="message"
                :messagetitle="messagetitle"
                :messagetype="messagetype"
             >
             </Alert>
            </v-card>
                
            </v-dialog>
</v-card-text>
</v-card>
</div>
</template>
<script>
export default {
  head: {
    title() {
      return {
        inner: 'プレスリリース作成',
        separator: '|',
        complement: 'PR効果測定 Qlipper',
      }
    },
      link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/relcreate.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "./css/editor.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
  },

  props : ['selected_id','conf_id','sch_id',],
  // データ
  computed : {
        temp_id : function(){
            return this.$store.getters['doc_info/get_temp_id'];
        },
		reserv_ok : function(){
			return [this.reserv_flg , this.reservable];
		},
        doc_id : function() {
            return this.$store.getters['doc_info/get_doc_id'];
        },
        title : function() {
            return this.$store.getters['doc_info/get_title'];
        },
        sub_title : function() {
            return this.$store.getters['doc_info/get_subtitle'];
        },
        summary : function() {
            return this.$store.getters['doc_info/get_summary'];
        },
        doc_signature : function(){
            return this.$store.getters['doc_info/get_signature'];
        },
        direction : function(){
            return this.$store.getters['doc_info/get_direction'];
        },
        e_doc : function() {
            return this.$store.getters['doc_info/get_doc'];
        },
        ai_doc : function() {
            return this.$store.getters['doc_info/get_ai_doc'];
        },
        schedule_id : function() {
            return this.$store.getters['doc_info/get_schedule_id'];
        },
        release_date : function(){
            let release_date = this.$store.getters['doc_info/get_release_date'];
            if(release_date == "")
            {
                release_date = "日付未設定";
            }
            else
            {
                release_date = moment(release_date).format("YYYY年MM月DD日");
            }
            return release_date;
        },
        save_release_date : function(){
            return this.$store.getters['doc_info/get_release_date'];
        },
        loading_flg : function(){
            return this.$store.getters['doc_info/get_loading'];
        },
        save_flg : function(){
            return this.$store.getters['doc_info/get_save'];
        },
        set_conf_id : function(){
            return this.$store.getters['doc_info/get_conf_id'];
        },
        status : function(){
            return this.$store.getters['doc_info/get_status'];
        },


    },
    watch : {
        temp_id   : function(){
			if(this.temp_id == "")
				return ;
			this.get_temp();
        },
		reserv_ok : async function(){
			if(this.reserv_flg == true && this.reservable == true)
			{
				this.save_doc();
				var params = new URLSearchParams();
				params.append("old_block_id",this.block_history.old_id);
				params.append("new_block_id",this.block_history.new_id);
				params.append("doc_id",this.doc_id);
				await axios.post("/doc/set_newcomment_id",params)
				.then(() => {
					this.$refs.cor.updated(this.block_history.new_id);
					this.reserv_flg = false;
					this.block_history = null;
				})
				.catch((error) => {
					console.error('失敗です', error);
					window.location.href="https://qlipper.jp/login";
				});
			}
		},
		status : function(){
			console.log("更新された");
		},
        loading_flg : function(){
            if(this.loading_flg==false)
            {
                this.hideLoading();
            }
            else
            {
                this.showLoading();
            }
        },
        config_loaded_flg : function(){
            if(this.config_loaded_flg==true)
            {
                this.gpt_move();
            }
        },
    },
    data: function(){
        // リリース関連関連
        return {
		tab : null,
		template_id : "",
		move        : 1 ,
		comment_cnt : 0,
        message_flg : false,
        messagetitle: "",
        message     : "",
        messagetype : 0,
        editor_status : {},    
        load_flg      : false,
        gpt_flg       : false,
        config_loaded_flg : false,
        // スケジュールダイアログ
        items: [
          { title: '印象評価', icon: 'mdi-monitor-eye' },
          { title: 'リリース管理', icon: 'mdi-format-list-bulleted' },
          { title: '保存', icon: 'mdi-content-save-edit-outline' },
          { title: 'ダウンロード', icon: 'mdi-cloud-download-outline' },
          { title: '宛名/署名設定', icon: 'mdi-cog' },
          { title: 'プレビュー', icon: 'mdi-eye-check' },
          { title: 'AIで作成', icon: 'mdi-robot' },
        ],
        right: null,
        menu : false,
        elem_flg  : false,
        keeper    : null,
		reserv_flg : false,
		reservable : true,
		block_history : null,
        };
    },
      // 各処理
    methods: {
		download : function(){
            if(this.title == "" || this.title == null)
            {
                this.messagetitle = "タイトルが入力されていません。";
                this.message      = "保存やダウンロードにはタイトルが必須項目です";
                this.messagetype  = 2;
                this.message_flg=true;
                return ;
            }
            this.$nextTick(function (){
                const elem = document.getElementById("dl");
                elem.submit();
            });
		},
		reload : function(){
			this.load_flg = false;
			this.$store.commit("doc_info/set_ai_copy");
			this.$nextTick(()=>{
				this.load_flg=true;
			});
		},
		get_temp : async function(){
			this.load_flg = false;
			if(this.temp_id == "")
			{
				return ;
			}
			var params = new URLSearchParams();
			params.append("id",this.temp_id);
			await axios.post("/api/release/get_template_list",params)
			.then(response => {
				if(response.data.length == 0)
				{
					this.load_flg = true;
					return;
				}
				this.$store.commit("doc_info/set_doc",{
					"title"     : response.data[0].title,
					"sub_title" : response.data[0].sub_title,
					"summary"   : response.data[0].summary,
					"doc"       : response.data[0].doc,
				});
				window.scroll({top: 0, behavior: 'smooth'});
				this.load_flg = true;
			}).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
		},

		status_update : function(){
			// 保存OK
			this.reservable = true;
		},
        product_load : async function(){
            var params = new URLSearchParams();
            await axios.post("/api/gpt/get_product",params)
            .then(response => {
                response.data;
                this.$store.commit("product_list/set_product_list",response.data);
                this.$store.commit("product_list/set_load");
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
		save_reserv : function(data){
			this.reservable = false;
			this.reserv_flg = true;
			this.block_history = data;
		},
        save_doc : async function(){
            if(this.title == "" || this.title == null)
            {
                this.messagetitle = "タイトルが入力されていません。";
                this.message      = "保存やダウンロードにはタイトルが必須項目です";
                this.messagetype  = 2;
                this.message_flg=true;
                return ;
            }

            var params = new URLSearchParams();
            params.append("title",this.title);
            params.append("sub_title",this.sub_title);
            params.append("summary",this.summary);
            params.append("doc",this.e_doc);
            params.append("conf_id",this.set_conf_id);
            params.append("schedule_id",this.schedule_id);
            params.append("temp_id",this.temp_id);
            params.append("release_date",this.save_release_date);
            params.append("id",this.doc_id);
            await axios.post("/api/release/save_doc",params)
            .then(response => {
                this.$store.commit("doc_info/set_doc_id",response.data.id);
                // doc_id の存在チェックをして通知する
                // スケジュールIDの存在チェックをして通知する
                if(response.data.schedule_id != undefined)
                    this.$store.commit("doc_info/set_schedule_id",response.data.schedule_id);

                this.messagetitle = "保存しました";
                this.message      = "保存したドキュメントは一覧から確認できます";
                this.messagetype  = 0;
                this.message_flg=true;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        selected_img : function(data){
            this.$refs.ed.insertIMG(data.uuid);
        },
        robots_sub_form : function(data){
            this.$refs.gpt.text_open(data.flg);
        },
        conf_open   : function(){
            this.$refs.anal.config();
        },
        gpt_move    : function(){
            this.$refs.gpt.move();
        },
        gpt_switch  : function(){
            if(this.gpt_flg == true)
            {
                this.gpt_flg=false;
            }
            else
            {
                this.gpt_flg=true;
            }
        },
        config_loaded : function(){
            this.config_loaded_flg=true;
        },
		get_comment_cnt : async function()
		{
            var params = new URLSearchParams();
            params.append("doc_id",this.doc_id);
            await axios.post("/api/release/get_comment_cnt",params)
            .then(response => {
				this.comment_cnt = response.data[0].cnt;
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
		},
		gptopen    : function(){
			this.$refs.ed.gpt_move();
		},
        editormenu : function(data){
            switch(data.index)
            {
            case 0:
                this.$refs.message.opendl();
                break;
            case 1:
                this.$router.push('/list');
                break;
            case 2:
                this.save_doc();
                break;
			case 3:
				this.download();
				break;
            case 4:
                this.$refs.gr.open(0);
                break;
            case 5:
                this.$refs.shr.open();
                break;
            default:
                break;
            }
        },
        garally : function()
        {
            this.$refs.gr.open(1)
        },
     },
    created  : function() {
        this.keeper = setInterval(function(){
            let params = new URLSearchParams();
            axios.post("/api/common/session_keeper",params)
            .catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },300000);
        
        // state の初期化
        this.$store.commit("doc_info/reset");
        // 商品情報の取得
        this.product_load();

        let params = new URLSearchParams();
        if(this.selected_id === undefined || this.selected_id=='' || this.selected_id == null)
        {
            this.gpt_flg=true;
            if(this.sch_id != null && this.sch_id != undefined && this.sch_id !=''){
                params.append('sch_id', this.sch_id);
                axios.post("/api/events/get_cal_one.php",params)
                .then(response => {
                    this.$store.commit("doc_info/set_val",{
                        "doc_id"        : "",
                        "title"         : "",
                        "sub_title"     : "",
                        "summary"       : "",
                        "doc"           : "",
                        "direction"     : "",
                        "signature"     : "",
                        "conf_id"       : "",
                        "therm"         : "",
                        "status"        : "",
                        "uuid"          : "",
                        "temp_id"       : "",
                        "share_flg"     : "",
                        "schedule_id"   : this.sch_id,
                        "release_date"  : response.data[0].start,
                    });
                    this.load_flg=true;
                }).catch((error) => {
                    window.location.href = 'https://qlipper.jp/login';
                    console.error('失敗です', error);
                });
            }
            else
            {
                this.load_flg=true;
            }
            return;
        }
        params.append('id', this.selected_id);

         axios.post("/api/release/get_userdoc",params)
        .then(response => {
            if(response.data["list"].length > 0)
            {
                let signature = response.data['list'][0].signature;
                if(response.data['list'][0].company_name != "" && response.data['list'][0].company_name != null)
                {
                    signature = response.data['list'][0].company_name + "\n" + response.data['list'][0].signature;
                }
                this.$store.commit("doc_info/set_val",{
                    "doc_id"        : response.data['list'][0].id,
                    "title"         : response.data['list'][0].title,
                    "sub_title"     : response.data['list'][0].sub_title,
                    "summary"       : response.data['list'][0].summary,
                    "doc"           : response.data['list'][0].doc,
                    "direction"     : response.data['list'][0].direction,
                    "signature"     : signature,
                    "conf_id"       : response.data['list'][0].conf_id,
                    "schedule_id"   : response.data['list'][0].schedule_id,
                    "release_date"  : response.data['list'][0].release_date,
                    "product_id"    : response.data['list'][0].product_id,
                    "therm"         : response.data['list'][0].therm,
                    "docstatus"     : response.data['list'][0].status,
                    "uuid"          : response.data['list'][0].uuid,
                    "temp_id"       : response.data['list'][0].temp_id,
                    "share_flg"     : response.data['list'][0].share_flg,
                });
                if(response.data['list'][0].migration == 't')
                {
                    this.$store.commit("doc_info/set_migration");
                }
                this.load_flg=true;
                this.get_comment_cnt();
            }
            else
            {
                this.gpt_flg=true;
            }
        }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
        });
      },
};
</script>
